Shopify.theme.sections.register('header', {

  _initScrollObserver: function() {
    function onElementNearTop(element) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.boundingClientRect.bottom < 0) {
            document.body.classList.remove('transparent-header');
          } else {
            document.body.classList.add('transparent-header');
          }
        });
      }, { root: null, threshold: 0 });
    
      observer.observe(element);
    }
    const targetElement = document.querySelector("#hero");
    if (targetElement) onElementNearTop(targetElement);
  },

  _initSliders: function() {
    const options = {
      swipeAngle: 25,
      preventScrollOnTouch: true,
      center: true,
      nav: false,
      mouseDrag: false,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayButtonOutput: false,
      autoplayHoverPause: true,
      speed: 650
    };
    tinySlider('top-bar', options);
  },

  onLoad: function() {

    if (stix_api.theme.template.type === 'index') {
      this._initScrollObserver();
    }
    this._initSliders();
  }

});